import { createContext } from "preact";
import { RewardServiceInterface } from "../interfaces";

export const RewardServiceContext = createContext<RewardServiceInterface | null>(null)